import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-1/2">
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold uppercase tracking-wider mb-4">
              Why Itaobuy
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              Why Itaobuy Spreadsheet Is Changing the Way People Manage Data
            </h2>
            <p className="mt-6 text-foreground-700 leading-relaxed text-base">
              Itaobuy Spreadsheet is more than a simple tool. It is a structured system designed to help users organize complex data in one place, track purchasing workflows efficiently, reduce manual errors, improve decision-making speed, and scale operations with clarity.
            </p>
            <p className="mt-4 text-foreground-700 leading-relaxed text-base">
              Unlike traditional spreadsheets that leave you with endless rows of unstructured data, Itaobuy Spreadsheet focuses on <strong>workflow intelligence combined with structured data logic</strong>, giving you a clear overview of every transaction, category, and trend at a glance.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/itaobuy-spreadsheet-guide"
                className="w-full sm:w-auto px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                Read the Full Guide
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-6 py-3 rounded-full border-2 border-primary-500 text-primary-600 font-semibold text-sm hover:bg-primary-50 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                Explore Features
                <i className="ri-external-link-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="lg:w-1/2 grid grid-cols-2 gap-4 w-full">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20minimal%20workspace%20photography%20of%20a%20sleek%20silver%20laptop%20on%20a%20cream%20desk%20with%20a%20ceramic%20mug%20and%20opened%20notebook%2C%20soft%20natural%20light%20streaming%20through%20sheer%20curtains%2C%20editorial%20style%2C%20gentle%20shadows%2C%20warm%20neutral%20beige%20tones%2C%20organic%20scandinavian%20aesthetic%20with%20a%20touch%20of%20greenery&width=600&height=500&seq=itaobuy-about-v2-01&orientation=portrait"
              alt="Organized workspace with laptop showing spreadsheet"
              className="w-full h-48 md:h-56 object-cover rounded-xl"
            />
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20product%20flat%20lay%20photography%20of%20a%20classic%20analog%20watch%20with%20brown%20leather%20strap%20resting%20on%20a%20folded%20cream%20linen%20napkin%20beside%20a%20small%20succulent%20plant%2C%20soft%20natural%20daylight%2C%20editorial%20composition%2C%20gentle%20shadows%2C%20warm%20neutral%20earthy%20tones%2C%20scandinavian%20minimalist%20style&width=600&height=500&seq=itaobuy-about-v2-02&orientation=portrait"
              alt="Elegant flat lay with watch and accessories"
              className="w-full h-48 md:h-56 object-cover rounded-xl mt-6"
            />
            <img
              src="https://readdy.ai/api/search-image?query=Minimal%20product%20photography%20of%20an%20amber%20glass%20bottle%20with%20a%20spray%20nozzle%20on%20a%20warm%20cream%20surface%20with%20a%20single%20dried%20wheat%20stem%20beside%20it%2C%20soft%20natural%20window%20light%2C%20editorial%20beauty%20aesthetic%2C%20gentle%20shadows%2C%20warm%20neutral%20beige%20tones%2C%20organic%20scandinavian%20still%20life%20composition&width=600&height=500&seq=itaobuy-about-v2-03&orientation=portrait"
              alt="Amber glass bottle with dried wheat on cream background"
              className="w-full h-48 md:h-56 object-cover rounded-xl"
            />
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20minimal%20desk%20setup%20photography%20of%20a%20white%20tablet%20displaying%20colorful%20data%20charts%20with%20a%20stylus%20pen%20resting%20on%20a%20cream%20desk%20mat%2C%20soft%20natural%20daylight%2C%20editorial%20tech%20aesthetic%2C%20gentle%20shadows%2C%20warm%20neutral%20beige%20tones%2C%20scandinavian%20minimalist%20office%20environment&width=600&height=500&seq=itaobuy-about-v2-04&orientation=portrait"
              alt="Modern desk setup with tablet showing charts"
              className="w-full h-48 md:h-56 object-cover rounded-xl mt-6"
            />
          </div>
        </div>
      </div>
    </section>
  );
}